import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonService } from "../../../services/api/mp-common.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { DataRightsState } from "../../models/mp-common/data-rights-state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class DataRightsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.dataRights.get),
			withLatestFrom(this.store.select(MpCommonSelectors.dataRights)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.dataRights.getSuccess(state))
					: of(MpCommonActions.dataRights.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.dataRights.getApi),
			switchMap(() =>
				this.marketplaceService.dataRights().pipe(
					map((dataRights) =>
						MpCommonActions.dataRights.getSuccess({ dataRights, loading: false })
					),
					catchError((error) =>
						of(MpCommonActions.dataRights.getFail(new FailState(error)))
					)
				)
			)
		)
	);
	constructor(
		private actions: Actions,
		private marketplaceService: MpCommonService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: DataRightsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
